import React, { Component } from 'react';
import './CollectionPage.css';
import '@shopify/polaris/dist/styles.css';
import { AppProvider } from '@shopify/polaris';
import Collection from '../components/Collection';
import { getFetch } from '../helpers/request';

interface CollectionPageProps {
  id: string,
  match: any
}

interface CollectionPageState {
  shopOrigin: string
}

class CollectionPage extends Component <CollectionPageProps, CollectionPageState> {

  constructor(props: CollectionPageProps) {
    super(props);
    this.state = {
      shopOrigin: ''
    };
  }

  componentDidMount() {
    //check if log in
    getFetch('/app/api/shopify/user', {})
    .then((res:any) => res.json()
    ).then(data => {
      this.setState({ shopOrigin: data.shop_origin })
    }).catch(err => {

    });
  }

  render() {
    return (
      this.state.shopOrigin !== '' &&
      <AppProvider i18n={{}}>
        <Collection shopOrigin={this.state.shopOrigin} type="existing" id={this.props.match.params.collectionId}></Collection>
      </AppProvider>
    );
  }
}

export default CollectionPage;
